var buttonsContainer = $('.shariff');

if (buttonsContainer.length) {
  new Shariff(buttonsContainer, {
    services:["facebook","twitter","xing","linkedin"],
    buttonStyle: 'icon',
    orientation: 'horizontal'
  });
}
